import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { Alert } from '../shared/Alert';
import { spacing02 } from '../styling/spacing';
import { UserContext } from '../users/UserContext';
import { Permission, userHasPermission } from './permission';

type Props = {
  requiredPermission: Permission;
  children: React.ReactNode;
};

export const AssertUserHasPermission = (props: Props) => {
  const user = useContext(UserContext).getUser();

  if (!userHasPermission({ user, permission: props.requiredPermission })) {
    return (
      <AlertContainer>
        <Alert
          type="warning"
          title="Insufficient Permissions"
          body={`This page requires the '${props.requiredPermission}' permission, which you do not have.`}
        />
      </AlertContainer>
    );
  } else {
    return <>{props.children}</>;
  }
};

const AlertContainer = styled.div`
  margin: ${spacing02} 0;
`;
